export default "__VITE_ASSET__fee33dff__"